<template>
    <vue-table-card title="News Category" :fields="fields" :url="listUrl" :per-page="10" ref="table">
        <template #buttons>
            <btn color="success" icon="fa fa-plus" size="sm" @click="$refs.addModal.show()" text="Add"/>
        </template>

        <template #actions="{rowData}">
            <div class="btn-group-tight">
                <delete-btn @click="setDelete(rowData)"/>
                <edit-btn @click="setEdit(rowData)"/>
            </div>
        </template>

        <template #footer>
            <modal title="Add News Category" ref="addModal" width="30r" header-color="primary" no-close-on-backdrop>
                <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}">
                    <validated-input label="Category Name" class="required-field"
                                     v-model="model.category_name"
                                     :rules="{required:true}"
                                     :disabled="loading"/>
                    <btn text="Save" loading-text="Saving..." size="sm" :disabled="loading" :loading="loading"/>
                </b-form>
            </modal>

            <modal title="Edit News Category" ref="editModal" width="30r" header-color="primary" no-close-on-backdrop>
                <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}" :initial-data="editingItem">
                    <validated-input label="Category Name"
                                     v-model="model.category_name"
                                     :rules="{required:true}"
                                     :disabled="loading"/>
                    <btn text="Update" loading-text="Updating..." size="sm" :disabled="loading" :loading="loading"/>
                </b-form>
            </modal>

            <delete-modal ref="deleteModal" :url="deleteUrl" :params="deletingItem" @response="deleteComplete">
                <p>You are about to delete the category <b v-html="deletingItem && deletingItem.category_name"></b>. Are you sure ?</p>

                <template #loading>
                    <loading-animation/>
                    Please wait while we delete <b v-html="deletingItem && deletingItem.name"></b>.
                </template>
            </delete-modal>
        </template>

    </vue-table-card>
</template>

<script>
import urls from '@/data/urls';

export default {
    name: 'NewsCategory',
    data () {
        return {
            listUrl: urls.masterData.NewsCategory.list,
            addUrl: urls.masterData.NewsCategory.addEdit,
            deleteUrl: urls.masterData.NewsCategory.delete,
            editingItem: null,
            deletingItem: null,
            fields: [
                {
                    name: 'id',
                    sortField: 'id',
                    title: 'ID'
                },
                {
                    name: 'category_name',
                    sortField: 'category_name',
                    title: 'Category Name'
                },
                {
                    name: '__slot:actions',
                    titleClass: 'center aligned text-right',
                    dataClass: 'aligned text-right'
                }
            ],
            rules: {
                state: {
                    required: true
                }
            }
        };
    },
    methods: {
        viewDetails (id) {
            this.$router.push('/banner/' + id + '/details/');
        },
        formSuccess () {
            const refs = this.$refs;
            refs.addModal.close();
            refs.editModal.close();
            this.$emit('refresh');
            refs.table.refreshTable();

            this.editingItem = null;
        },

        setEdit (item) {
            this.editingItem = { ...item };
            this.$refs.editModal.show();
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.$refs.deleteModal.show();
        },

        deleteComplete (response) {
            this.deletingItem = null;
            this.$refs.deleteModal.close();
            this.$emit('refresh');
            this.$notify('Deleted Successfully', 'Success', {
                type: 'success'
            });
            this.$refs.table.refreshTable();
        }
    }
};
</script>

<style scoped>

</style>
